import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPublicFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 17.6701L16 15.6701L13.052 13.6891L11.109 13.5651L10 14.6701L12 17.6701H15Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.813 3.03498C8.72854 2.67984 5.16152 5.03154 3.70198 8.5L7.99999 11.6701L9.00499 9.67508L13 8.67008L14.5 3.35193C13.9558 3.193 13.3915 3.08541 12.813 3.03498Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.813 3.03498C7.18898 2.54598 2.54598 7.18898 3.03498 12.813C3.40698 17.092 6.90698 20.592 11.186 20.964C16.81 21.453 21.453 16.811 20.964 11.186C20.592 6.90798 17.092 3.40798 12.813 3.03498ZM12.813 3.03498C8.72854 2.67984 5.16152 5.03154 3.70198 8.5L7.99999 11.6701L9.00499 9.67508L13 8.67008L14.5 3.35193C13.9558 3.193 13.3915 3.08541 12.813 3.03498ZM15 17.6701L16 15.6701L13.052 13.6891L11.109 13.5651L10 14.6701L12 17.6701H15Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgPublicFilled);
export default ForwardRef;
